// iter 284: mobile catalog filters — same fields and query params as the desktop FilterBar/Dashboard.
export const EMPTY_FILTERS = {
  q: "", budget_no: "", factory_name: "", purchaser: "", external_sales: "", contract_no: "", invoice_no: "", tag: "",
  category: "", product_type: "", approval: "",
  min_qty: "", max_qty: "", min_shipping_qty: "", max_shipping_qty: "", min_ci_qty: "", max_ci_qty: "",
  has_samples: false, sample_warehouse_id: "", date_field: "contract_date", date_from: "", date_to: "",
};

const TEXT_KEYS = ["budget_no", "factory_name", "purchaser", "external_sales", "contract_no", "invoice_no", "tag", "category", "product_type", "approval",
  "min_qty", "max_qty", "min_shipping_qty", "max_shipping_qty", "min_ci_qty", "max_ci_qty", "sample_warehouse_id"];

export function buildInventoryParams(filters) {
  const params = {};
  TEXT_KEYS.forEach((k) => { if (filters[k] !== "" && filters[k] != null) params[k] = filters[k]; });
  if (filters.has_samples) params.has_samples = true;
  if (filters.date_from || filters.date_to) {
    params.date_field = filters.date_field || "contract_date";
    if (filters.date_from) params.date_from = filters.date_from;
    if (filters.date_to) params.date_to = filters.date_to;
  }
  return params;
}

// Number of filter groups in use (q excluded: it has its own search box). Ranges/date count once.
export function activeFilterCount(filters) {
  let n = 0;
  ["budget_no", "factory_name", "purchaser", "external_sales", "contract_no", "invoice_no", "tag", "category", "product_type", "approval", "sample_warehouse_id"]
    .forEach((k) => { if (filters[k]) n += 1; });
  if (filters.has_samples) n += 1;
  if (filters.min_qty !== "" || filters.max_qty !== "") n += 1;
  if (filters.min_shipping_qty !== "" || filters.max_shipping_qty !== "") n += 1;
  if (filters.min_ci_qty !== "" || filters.max_ci_qty !== "") n += 1;
  if (filters.date_from || filters.date_to) n += 1;
  return n;
}
